import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { CardItem, Enums, InfoTooltip, StatusCard, UserAgent } from 'Mri.Web.Common';
import * as React from 'react';
import { ActiveDisplay } from '../../ActiveDisplay';

export interface IDisplayConnectionCardProps {
    readonly display: ActiveDisplay;
    readonly loading?: boolean;
    readonly statusPoll?: Mri.DisplayStatuses.DisplayStatusPoll;
}

@observer
export class DisplayConnectionCard extends React.Component<IDisplayConnectionCardProps> {
    public render() {
        const { display } = this.props;

        return (
            <StatusCard title={this.title()} loading={this.props.loading}>
                {display.displayConnectionData && (
                    <>
                        <InfoTooltip message={this.networkString ?? 'No Networking Information available'}>
                            <CardItem
                                label="Controller Network"
                                value={this.networkStringBrief}
                                dontRenderOnFalseValue
                            />
                        </InfoTooltip>

                        <CardItem
                            label="Player IP"
                            value={display.displayConnectionData.input1IP}
                            dontRenderOnFalseValue
                        />

                        <CardItem
                            label="Player 2 IP"
                            value={display.displayConnectionData.input2IP}
                            dontRenderOnFalseValue
                        />

                        <CardItem
                            label="Camera IP"
                            value={display.displayConnectionData.cameraIP}
                            dontRenderOnFalseValue
                        />

                        <CardItem
                            label="Modem IP"
                            value={display.displayConnectionData.modemIP}
                            dontRenderOnFalseValue
                        />

                        <CardItem
                            label="Board IP"
                            value={display.displayConnectionData.displayBoardIP}
                            dontRenderOnFalseValue
                        />

                        <CardItem
                            label="Board Port"
                            value={display.displayConnectionData.displayBoardPort}
                            dontRenderOnFalseValue
                        />

                        <CardItem
                            label="Noc Server"
                            value={display.displayConnectionData.nocServer}
                            dontRenderOnFalseValue
                        />

                        <CardItem
                            label="Comments"
                            value={display.displayConnectionData.comments}
                            dontRenderOnFalseValue
                        />
                    </>
                )}

                {this.props.statusPoll?.systemInfo?.nodeInfo?.ipAddr && (
                    <>
                        <CardItem
                            label="Controller Local IP"
                            value={this.props.statusPoll.systemInfo.nodeInfo.ipAddr}
                        />
                    </>
                )}
            </StatusCard>
        );
    }

    private title() {
        return (
            <div>
                Connection Status
                <small className={'mx-2 ' + this.statusClassName}>{this.props.display.statusMessageBrief}</small>
            </div>
        );
    }

    @computed
    private get statusClassName() {
        if (!this.props.display) return;

        switch (this.props.display.state) {
            case 'good':
                return 'text-default';
            case 'exception':
                return 'text-info';
            case 'warning':
                return 'text-warning';
            case 'critical':
                return 'text-danger';
        }
    }

    // {DisplayBoardIP} via {SourceNetwork} network on ({NocServerName} server|MRI VPN)
    @computed
    private get networkStringBrief() {
        const { display } = this.props;
        const dcd = display.displayConnectionData;

        if (!dcd || !dcd.displayBoardIP) return;

        let networkString = `${dcd.displayBoardIP}`;

        if (dcd.sourceNetwork)
            networkString += ` via ${Enums.toString(Enums.SourceNetwork, dcd.sourceNetwork)} network`;

        if (dcd.nocServer == 'Global') networkString += ` on MRI VPN`;
        else if (dcd.nocServer) networkString += ` on ${dcd.nocServer} server`;

        return networkString;
    }

    // {SerialNumber} connected on the ({NocServerName server|MRI VPN) via the {SourceNetwork} network with Remote Address {DisplayBoardIP}
    @computed
    private get networkString() {
        const { display } = this.props;
        const dcd = display.displayConnectionData;

        if (!dcd || !dcd.displayBoardIP) return;

        let networkString = `${display.serialNumber} connected`;

        if (dcd.nocServer == 'Global') networkString += ` on the MRI VPN`;
        else if (dcd.nocServer) networkString += ` on the ${dcd.nocServer} server`;

        if (dcd.sourceNetwork)
            networkString += ` via the ${Enums.toString(Enums.SourceNetwork, dcd.sourceNetwork)} network`;

        networkString += ` with remote address ${dcd.displayBoardIP}`;

        return networkString;
    }
}
